import React from 'react';
import { 
  Box, 
  Typography, 
  Link
} from '@mui/material';
import { ContentCopy, OpenInNew, PhoneIphone, Computer } from '@mui/icons-material';

const MicrosoftFAQs = ({ onCopyLink }) => {
  return [
    {
      question: "I wasn't prompted to add the calendar.",
      answer: (
        <Box>
          <Box sx={{ mb: 2}}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1}}>
              <PhoneIphone sx={{ fontSize: 20 }} />
              Mobile
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Important:</strong> Outlook only lets you subscribe to a calendar on desktop. You can show or hide calendars you've already subscribed to, but you can't subscribe to a calendar in the Outlook app on mobile devices.
            </Typography>

            <Typography variant="h5" sx={{mt: 4, mb: 2, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Computer sx={{ fontSize: 20 }} />
              On the web
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 1: </strong>
              <Link onClick={onCopyLink} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                Copy this link 
                <ContentCopy sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 2: </strong>
              Open your browser to view your mailbox from there (not native Outlook for Mac or PC app). For example, {" "}
              <Link onClick={() => window.open('https://outlook.office.com', '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                https://outlook.office.com
                <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
              {" "} or {" "}
              <Link onClick={() => window.open('https://outlook.com', '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                https://outlook.com
                <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 3: </strong>
              On the left nav bar, choose the Calendar icon (second from the top) then scroll down to <b>Add Calendar</b>.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 4: </strong>
              Choose <b>Subscribe from web</b> and paste the calendar link from Stanza.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 5: </strong>
              A few little details to add:
              <br />
              • <b>Calendar Name</b> – make it short, to fit in the left-side calendar pane
              <br />
              • <b>Color</b> – each calendar is color-coded
              <br />
              • <b>Charm</b> – Microsoft's name for an icon, which appears beside each calendar item
              <br />
              • <b>Calendar</b> – which section to organize the calendar under. For example: "My Calendars", "Other Calendars" etc.
              <br /><br />
              The name, color, charm (icon) and calendar type can all be changed later.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 6: </strong>
              Click Insert then wait a moment. The new calendar will appear in the left-side calendar pane, at the bottom.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Step 7: </strong>
              <Link onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                Confirm that everything is working
              </Link>
              {" "} as expected or {" "}
              <Link onClick={() => window.open(`https://docs.google.com/forms/d/e/${process.env.REACT_APP_SUPPORT_FORM_ID}/viewform`, '_blank')} sx={{ cursor: "pointer", textDecoration: "underline" }}>
                submit a ticket
                <OpenInNew sx={{ fontSize: 14, ml: 0.5 }} />
              </Link>
              {" "} if you continue to have issues.
            </Typography>
          </Box>
        </Box>
      )
    },
    {
      question: "My events aren't updating.",
      answer: "Microsoft calendars can take up to 24 hours to sync. Check that you're signed into the correct Microsoft account."
    }
  ];
};

export default MicrosoftFAQs;